<template>
  <div class="help-center-footer-socials__component">
    <a
      v-for="link in links"
      :key="link.icon"
      :href="link.url"
      :title="link.title"
      :class="link.class"
      class="help-center-footer-socials__link"
      target="_blank"
      rel="noopener"
    >
      <i
        class="help-center-footer-socials__icon"
        :class="link.icon"
      />
    </a>
  </div>
</template>

<script setup>
const links = [{
  url: 'https://facebook.com/Gleamapp',
  icon: 'fab fa-facebook-f',
  class: 'help-center-footer-socials__link--facebook',
  title: 'Connect With Us on Facebook'
}, {
  url: 'https://twitter.com/gleamapp',
  icon: 'fab fa-x-twitter',
  class: 'help-center-footer-socials__link--xtwitter',
  title: 'Connect With Us on X'
}, {
  url: 'https://linkedin.com/company/gleam-io',
  icon: 'fab fa-linkedin-in',
  class: 'help-center-footer-socials__link--linkedin',
  title: 'Connect With Us on Linkedin'
}]
</script>

<style lang="scss">
@import 'help-center/mixins';

$socials: facebook, xtwitter, linkedin;

.help-center-footer-socials {
  &__component {
    gap: 8px;
    display: flex;
  }

  &__link {
    @include help-center-link;
    display: flex;

    @each $social in $socials {
      &--#{$social} {
        color: help-center-brand-color($social);
      }
    }
  }

  &__icon {
    @include help-center-icon(16);
    flex: none;
  }
}
</style>
